import React, { useEffect } from "react";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import useSchedule from "./hooks/useSchedule";
import "./style.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";
import ExerciseBar from "./exerciseBar";
import ScheduleDesktop from "./scheduleDesktop";
import ScheduleMobile from "./scheduleMobile";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useSelector } from "react-redux";
import { State } from "../../store";
import EAPageHeader from "../shared/EAPageHeader";
import EAPageMessage from "../shared/EAPageMessage";
import { checkComponentActive } from "../../../utils/checkComponentActive";
import EAAlert from "../shared/EAAlert";
import { useTranslation } from "react-i18next";

const ScheduleExerise: React.FC = () => {
  const { t } = useTranslation();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const {
    today,
    nextWeek,
    previousWeek,
    dateToState,
    dateFromState,
    previousDay,
    nextDay,
    dayFromStateMobile,
    dayToStateMobile,
    getFirstAllExercises,
    exercisesList,
    loading,
    refreshExercisesList,
    filters,
    setFilters,
    selectMobileDate,
  } = useSchedule();

  useEffect(() => {
    getFirstAllExercises();
    //eslint-disable-next-line
  }, []);

  const matches = useMediaQuery("(min-width: 1100px)");

  if (checkComponentActive(saleConfiguration.componentList, "Calendar") === false) {
    return <EAAlert message={t("Nie znaleziono oferty")} type="error" />;
  }

  return (
    <div className="container">
      <EAPageHeader componentId="Calendar" />
      <EAPageMessage message={saleConfiguration.message_fitnessExercise} />

      <ExerciseBar
        nextWeek={nextWeek}
        previousWeek={previousWeek}
        dateToState={dateToState}
        dateFromState={dateFromState}
        filters={filters}
        setFilters={setFilters}
        previousDay={previousDay}
        nextDay={nextDay}
        dateFromStateMobile={dayFromStateMobile}
        dateToStateMobile={dayToStateMobile}
        onMobileDateChange={selectMobileDate}
      />

      {matches ? (
        <ScheduleDesktop
          today={today}
          dateFromState={dateFromState}
          exercisesList={exercisesList}
          loading={loading}
          onRefreshExercises={refreshExercisesList}
        />
      ) : (
        <ScheduleMobile
          dateFromState={dayFromStateMobile}
          exercisesList={exercisesList}
          loading={loading}
          onRefreshExercises={() => refreshExercisesList(true)}
        />
      )}
    </div>
  );
};

export default ScheduleExerise;
